import * as React from 'react';

// Components
import { NotFound, Button } from '@shopee-user/business-customization-ui';
import IconNoInternet from './components/IconNoInternet';

// Hooks
import { useTranslation } from '@shopee-user/platform';

// Constants
import { Theme } from '@shopee-user/business-customization-logic';

// Styles
import styles from './style.scss';

function OfflineComponent(): JSX.Element {
  const I18n = useTranslation();

  React.useEffect(() => {
    if (document.body) {
      document.body.style.backgroundColor = Theme.ColorBackgroundPrimary;
    }
  }, []);

  return (
    <NotFound
      icon={IconNoInternet}
      title={I18n.t('label_offline_title')}
      subtitle={I18n.t('label_offline_description')}
      className={styles.styleCenterAndFixed}
      actionButton={
        <Button
          className={styles.button}
          onClick={() => location.reload()}
          text={I18n.t('label_offline_try_again')}
        />
      }
    />
  );
}

export default OfflineComponent;
